<template>
  <div class="title-container">
    <slot>
      <div class="main-title">{{ pageTitle }}</div>
    </slot>
  </div>
</template>

<script>
export default {
  props: [ 'pageTitle' ],
};
</script>

<style scoped>
.title-container {
  border-top: 3px solid transparent;
  background: transparent;
  text-align: center;
  padding: 10px 0;
}

.main-title {
  margin: 0;  
  font-size: 35px;
  line-height: 35px;
  font-weight: 500;
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>